/**
 * Avoid writing arrow functions all the time in fat containers
 * @param obj
 * @returns {function(*)}
 */
export default function updateStateField(obj) {
  return st => ({ ...st, ...obj });
}